import { createApiClient } from "@estaly/ui";
import store from "../../store";
import { rollbar } from "../../rollbar";

export const ApiUrl = process.env.VUE_APP_API_BASE_URL;

export const { plainAxiosInstance, securedAxiosInstance } = createApiClient({
  apiUrl: ApiUrl,
  getStore: () => store,
  rollbar,
  appNamespace: "store",
});
